<template>
<div>
  <vs-table :data="yearlyRates" class="noscroll">
    <template slot="thead" >
      <vs-th width="200px">{{ $t("CashFlow.YearlyInflationRate.Category")}}</vs-th>
      <vs-th width="110px" style="min-width: 110px;" v-for="(year, index) in years" :key="index">
        <span>
          {{ year }}
        </span>
      </vs-th>
    </template>
    <template slot-scope="{data}">
      <vs-tr v-for="d in data" :key="d.category">
        <vs-td :data="d.category">
          <vs-row>
            <vs-col>
              {{ getCategoryName(d.category) }}
            </vs-col>
          </vs-row>
        </vs-td>
        <vs-td :data="d.values[index].rate" align="center" v-for="(value, index) in d.values" :key="index">
          <ValidationProvider :name="$t('CashFlow.YearlyInflationRate.Rate')" immediate rules="required|decimal|between:0,100" v-slot="{ errors }">
            <vs-input :disabled="readOnly" v-model="d.values[index].rate" class="w-full" v-if="d.values[index].id!=null" v-on:change="onEditRate($event, d.values[index].id)" :title="getOriginalRateDesc(d.values[index].originalRate)"/>
            <span v-if="d.values[index].id==null">N/A</span>
            <validation-message>{{ errors[0] }}</validation-message>
          </ValidationProvider>
        </vs-td>
      </vs-tr>
    </template> 
  </vs-table>
</div>

</template>
<script>

import {
  ValidationMessage
} from "@/app/shared/components";

export default {
  /* eslint-disable vue/no-unused-components */
  components: {
    ValidationMessage
  },
  props: {
    readOnly : {
      type: Boolean,
      default: false
    },
    yearlyRates: {
      type: Array,
      default: () => {}
    }
  },
  data() {
    return {
      isMounted: false,
      context: { componentParent: this }
    };
  },

  computed: {
    years () {
      return this.$props.yearlyRates.map(item => item.values.map(v => v.year))[0];
    }
  },

  methods: {
    getCategoryName(category) {
      return this.$t("CashFlow.InflationCategory." + category);
    },
    getOriginalRateDesc(value) {
      return this.$t("CashFlow.YearlyInflationRate.OriginalRate") + value;
    },
    onEditRate(event, yearlyInflationRateId) {
      const value = event.target.value;
      if (value === null || value === "") {
        return;
      }

      if (Number(value) === 0) {
        this.deleteRate(yearlyInflationRateId);
        return;
      }

      this.$cqrsPost('cashflow/lom/yearlyInflationRateTemplates/EditYearlyRate', { 
        id: yearlyInflationRateId,
        rate: value
      }).finally(() => {
        this.$vs.loading.close();
      });
    },
    deleteRate(yearlyInflationRateId) {
      this.$cqrsPost('cashflow/lom/yearlyInflationRateTemplates/DeleteYearlyRate', { 
        id: yearlyInflationRateId
      }).then(() => {
        const flattenedYearlyRates = this.yearlyRates.flatMap(x => x.values);
        const nowDeletedRate = flattenedYearlyRates.find(x => x.id === yearlyInflationRateId);
        nowDeletedRate.id = null;
        nowDeletedRate.rate = null;
      }).catch((response) => {
        console.log(response);
      });
      
    }
  }
};
</script>

<style lang="scss">
  .noscroll {
    overflow: initial !important;
  }

</style>